module.exports = __webpack_public_path__ + "img/19@2x.ea36bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/19@2x.png
// module id = MzRT
// module chunks = 0